import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Header from "../../header/Header";
import Titulo from "../../../atoms/titles/Titulo";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import Footer from "../../footer/Footer";
import { useNavigate } from "react-router-dom";
import { verDocumentoPDF } from "../../../services/DocumentosService";
const DescargarDocumentosActos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  
  const params = useParams();
  
  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState("");
  useEffect(() => {
    verDocumentoPDF(params?.idActo, params?.idDoc).then((data) => {
      if (!data || data.toString().startsWith("Error:")) {
          // si el service devuelve "Error: ..." (o no hay data), cortamos spinner
          setLoading(true);
          return;
        }
      
      if (!data.toString().startsWith("Error:")) {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          
          setSolicitud(base64data);
          setLoading(true);
        };
      }    });
  }, [params?.idActo, params?.idDoc]);
  
  
  return (
    <>
      <Header></Header>
      <div className="container d-flex flex-column card mt-5" id="inicio" role="main" data-landmark-index="4">
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login fondo">
                <div className="tituloSolicitud">
                  <div className="d-flex align-items-center flex-column">
                    <Titulo
                      titulo={location?.state?.tipoActo === "s1" ? 
                        "Acto S1 Variación de datos personales" : 
                        location?.state?.tipoActo === "z9" ? "Acto Z9 Reconocimiento de Nivel de Carrera" : ""}
                      tipo={"tituloPagina subTituloPagina"}
                    />
                    {/* <p className="text-third-1">{datos.estado}</p> */}
                  </div>
                  <div className="datosPersonalesCarrera d-flex flex-column m-2">
                    <div>
                      <div className="d-flex justify-content-between">
                        <Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"4. Descargar"}
                        ></Titulo>
                      </div>
                      <div className="separador"></div>
                    </div>

                    <div className="formulario">
                      <>
                        <div className="m-2"></div>
                        <div className="m-3 card scroll-list container-list-border">
                          <div className="gridPresentar">
                            <div className="iframePresentar pt-3">
                              {/* {alert("pdfobtenido",solicitud.split(",")[1])} */}
                              <object
                                data={solicitud}
                                type="application/pdf"
                                height="500"
                                width="100%"
                                aria-label="PDF del borrador"
                                className="rounded"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                      <div className="gridBotones mb-2">
                        <button
                          id="volver"
                          className="btnRed rounded btnCancelarDocumentacion"
                          type="button"
                          onClick={() => {
                            
                            if (location?.state.tipoActo === "z9") {
                              navigate(`/documentosActos/${params?.idActo}`,{state: {tipoActo:"z9"}})
                            } else if (location?.state.tipoActo === "s1") {
                              navigate(`/documentosActos/${params?.idActo}`,{state: {tipoActo:"s1"}})
                            }
                          }}
                        >
                          <i className="fa-solid fa-rotate-left"></i> Volver
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <SpinnerCircle></SpinnerCircle>
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};
export default DescargarDocumentosActos;
